<div class="topbar user-select-none">
  <div class="topbar-left">
    <div class="topbar-title-wrapper" [hidden]="!hasTitle()">
      <div class="topbar-title" #titleRef>
        <ng-content select="[app-topbar-title]"></ng-content>
      </div>
    </div>

    <div class="topbar-content">
      <ng-content></ng-content>
    </div>
  </div>
  <div *ngIf="brand" class="topbar-brand" [class.topbar-brand__client-customized]="!!clientCustomization?.enabled">
    <img *ngIf="clientCustomization?.enabled && !!logoUrl"
      class="topbar-brand__logo" [src]="logoUrl" [alt]="clientCustomization?.logoText" />
    <div *ngIf="!(clientCustomization?.enabled && !!logoUrl)"
      class="topbar-brand__logo-text">
        <span>{{clientCustomization?.logoText}}</span>
    </div>
  </div>
</div>
